import React from 'react';
import "./Average_Rating.css";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { ProgressBar } from 'react-bootstrap';

function Average_Rating({avg_rating,product}) {
    const ratings = [
        { stars: 5, percentage: 90 },
        { stars: 4, percentage: 60 },
        { stars: 3, percentage: 40 },
        { stars: 2, percentage: 30 },
        { stars: 1, percentage: 0 },
    ];

   

    return (
<section className="Average_Rating">

    <div className="average_wrapper">

        {/* Left Circle */}

        <div className="left_rating">

            <div className="rating_circle">

                <h1>
                    {Number(avg_rating?.average_rating || 0).toFixed(1)}
                </h1>

                <span>OUT OF 5</span>

                <Rating
                    readonly
                    initialRating={Number(avg_rating?.average_rating)}
                    emptySymbol={<FontAwesomeIcon icon={farStar} />}
                    fullSymbol={<FontAwesomeIcon icon={fasStar} color="#970202" />}
                    fractions={2}
                />

            </div>

          

        </div>

        {/* Divider */}

        <div className="rating_divider"></div>

        {/* Right Bars */}

        <div className="rating_breakdown">

            {avg_rating?.rating_counts?.map((rating,index)=>(

                <div className="rating_row" key={index}>

                    <span>{rating.name}</span>

                    <ProgressBar
                        now={rating.percentage}
                    />

                    <span>{rating.percentage}%</span>

                </div>

            ))}

        </div>

    </div>

</section>
    );
}

export default Average_Rating;
